{
  "author": "floris@xylex.group",
  "bin": {
    "athena-js": "bin/athena-js.js"
  },
  "dependencies": {
    "blessed": "^0.1.81",
    "chalk": "^4.1.2",
    "cron-parser": "^4.9.0",
    "jose": "^6.2.3",
    "pg": "^8.16.0",
    "server-only": "^0.0.1",
    "use-sync-external-store": "^1.5.0",
    "uuid": "^9.0.1",
    "zod": "^4.0.1"
  },
  "description": "Athena JS SDK",
  "devDependencies": {
    "@react-email/components": "^1.0.12",
    "@react-email/render": "^2.0.8",
    "@types/blessed": "^0.1.25",
    "@types/node": "^20.10.5",
    "@types/pg": "^8.15.1",
    "@types/react": "^18.3.12",
    "@types/react-test-renderer": "^18.3.1",
    "@types/uuid": "^9.0.7",
    "@typescript-eslint/eslint-plugin": "^8.57.0",
    "@typescript-eslint/parser": "^8.57.0",
    "eslint": "^8.57.1",
    "express": "^4.22.2",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-test-renderer": "^18.3.1",
    "tsup": "^8.5.1",
    "tsx": "^4.7.0",
    "typescript": "^5.3.3"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "exports": {
    ".": {
      "browser": {
        "default": "./dist/browser.js",
        "import": "./dist/browser.js",
        "require": "./dist/browser.cjs",
        "types": "./dist/browser.d.ts"
      },
      "default": "./dist/index.js",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "types": "./dist/index.d.ts"
    },
    "./admin": {
      "default": "./dist/admin.js",
      "import": "./dist/admin.js",
      "require": "./dist/admin.cjs",
      "types": "./dist/admin.d.ts"
    },
    "./billing": {
      "default": "./dist/billing.js",
      "import": "./dist/billing.js",
      "require": "./dist/billing.cjs",
      "types": "./dist/billing.d.ts"
    },
    "./browser": {
      "default": "./dist/browser.js",
      "import": "./dist/browser.js",
      "require": "./dist/browser.cjs",
      "types": "./dist/browser.d.ts"
    },
    "./cookies": {
      "default": "./dist/cookies.js",
      "import": "./dist/cookies.js",
      "require": "./dist/cookies.cjs",
      "types": "./dist/cookies.d.ts"
    },
    "./next/client": {
      "default": "./dist/next/client.js",
      "import": "./dist/next/client.js",
      "require": "./dist/next/client.cjs",
      "types": "./dist/next/client.d.ts"
    },
    "./next/server": {
      "default": "./dist/next/server.js",
      "import": "./dist/next/server.js",
      "require": "./dist/next/server.cjs",
      "types": "./dist/next/server.d.ts"
    },
    "./organization": {
      "default": "./dist/organization.js",
      "import": "./dist/organization.js",
      "require": "./dist/organization.cjs",
      "types": "./dist/organization.d.ts"
    },
    "./package.json": "./package.json",
    "./react": {
      "default": "./dist/react.js",
      "import": "./dist/react.js",
      "require": "./dist/react.cjs",
      "types": "./dist/react.d.ts"
    },
    "./social-providers": {
      "default": "./dist/social-providers.js",
      "import": "./dist/social-providers.js",
      "require": "./dist/social-providers.cjs",
      "types": "./dist/social-providers.d.ts"
    },
    "./utils": {
      "default": "./dist/utils.js",
      "import": "./dist/utils.js",
      "require": "./dist/utils.cjs",
      "types": "./dist/utils.d.ts"
    }
  },
  "files": [
    "dist",
    "bin",
    "README.md",
    "LICENSE"
  ],
  "keywords": [
    "database",
    "driver",
    "api-gateway",
    "sdk",
    "react",
    "hooks",
    "http",
    "postgres",
    "query-builder"
  ],
  "license": "MIT",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "name": "@xylex-group/athena",
  "peerDependencies": {
    "@react-email/components": ">=1.0.0",
    "@react-email/render": ">=2.0.0",
    "react": ">=17.0.0"
  },
  "peerDependenciesMeta": {
    "@react-email/components": {
      "optional": true
    },
    "@react-email/render": {
      "optional": true
    },
    "react": {
      "optional": true
    }
  },
  "publisher": "XYLEX Group",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xylex-group/athena-js.git"
  },
  "scripts": {
    "build": "tsup",
    "check:all": "pnpm lint && pnpm typecheck && pnpm test && pnpm build",
    "dev": "tsup --watch",
    "docs:methods": "node scripts/generate-sdk-method-reference.mjs",
    "docs:site:check": "pnpm --dir ../../apps/docs docs:sync-athena-js:check",
    "docs:site:sync": "pnpm --dir ../../apps/docs docs:sync-athena-js",
    "example:api-call": "cd examples/api-call && bun run start",
    "example:email-resend": "cd examples/email-resend && bun run start",
    "example:express-api": "cd examples/express-api && bun run start",
    "example:order-saga": "cd examples/order-saga && bun run start",
    "example:postgres-connection": "cd examples/postgres-connection && bun run start",
    "example:recurring-invoice": "cd examples/recurring-invoice && bun run start",
    "example:retry-patterns": "cd examples/retry-patterns && bun run start",
    "lint": "eslint \"src/**/*.ts\" \"test/**/*.ts\"",
    "lint:fix": "pnpm lint -- --fix",
    "prepublishOnly": "pnpm typecheck && pnpm build",
    "publish:token": "node scripts/publish.js",
    "test": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/*.test.ts",
    "test:integration:postgres": "node scripts/run-postgres-introspection-test.mjs",
    "test:watch": "node --import ./test/register-server-only.mjs --import tsx --test --watch test/*.test.ts",
    "typecheck": "tsc -p tsconfig.typecheck.json"
  },
  "sideEffects": false,
  "type": "module",
  "types": "./dist/index.d.ts",
  "typesVersions": {
    "*": {
      "*": [
        "dist/index.d.ts"
      ],
      "admin": [
        "dist/admin.d.ts"
      ],
      "billing": [
        "dist/billing.d.ts"
      ],
      "browser": [
        "dist/browser.d.ts"
      ],
      "cookies": [
        "dist/cookies.d.ts"
      ],
      "next/client": [
        "dist/next/client.d.ts"
      ],
      "next/server": [
        "dist/next/server.d.ts"
      ],
      "organization": [
        "dist/organization.d.ts"
      ],
      "react": [
        "dist/react.d.ts"
      ],
      "social-providers": [
        "dist/social-providers.d.ts"
      ],
      "utils": [
        "dist/utils.d.ts"
      ]
    }
  },
  "version": "3.0.2"
}